//import { gsap } from "gsap";
//import { Power0 } from 'gsap/all';
import Splide from '@splidejs/splide';
import { AutoScroll } from '@splidejs/splide-extension-auto-scroll';
import { Intersection } from '@splidejs/splide-extension-intersection';
(function() {
	'use strict'; 

	document.addEventListener('DOMContentLoaded', (event) =>{

		//wait until images, links, fonts, stylesheets, and js is loaded
 		window.addEventListener('load', (e) => {
			
			const carousels = document.querySelectorAll('.carousel-product-reviews');
			if( carousels ) {

				// 2. Define the options (optional)
				const options = {
					root: null, // observes intersection relative to the document's viewport
					rootMargin: '0px', // no margin
					threshold: 0.1 // fires the callback when 10% of the element is visible
				};

				//return
				carousels.forEach((element) => {

					// 4. Create the observer and start observing
					//const observer = new IntersectionObserver(callback, options);

					const slides = element.querySelectorAll('.splide__slide');

					let autoStart =  element.getAttribute('data-auto-start');
					let pauseOnHover =  element.getAttribute('data-pause-onhover');
					let perPageAttr =  element.getAttribute('data-per-page');
					let scrollSpeed =  element.getAttribute('data-speed');
					let arrows =  element.getAttribute('data-arrows');
					let lazyload =  element.getAttribute('data-lazyload');
					let pagination =  element.getAttribute('data-pagination');
					let gap =  element.getAttribute('data-gap');

					if( autoStart === 'true' ) {
						autoStart = true;
					} else {
						autoStart = false;
					}

					if( lazyload === 'true' ) {
						lazyload = true;
					} else {
						lazyload = false;
					}

					if( !perPageAttr ) {
						perPageAttr = 1;
					}

					if( !scrollSpeed ) {
						scrollSpeed = .25;
					} else {
						scrollSpeed = parseFloat(scrollSpeed);
					}

					if( arrows === 'true' ) {
						arrows = true;
					} else {
						arrows = false;
					}

					if( pagination === 'true' ) {
						pagination = true;
					} else {
						pagination = false;
					}

					if( pauseOnHover === 'true' ) {
						pauseOnHover = true;
					} else {
						pauseOnHover = false;
					}

					if( !gap ) {
						gap = 8;
					} else {
						gap = parseInt(gap);
					}

					let direction = scrollSpeed;
					if( element.classList.contains('inverse-direction') ){
						direction = scrollSpeed * -1;
					}

					if( !slides || slides.length <= 0 ) {
						console.error('REVIEWS CAROUSEL EMPTY');
						return;
					}

					const primarySlider = new Splide( element, {
						//height : '500px',
						type   : 'loop',
						drag   : 'free',
						snap   : true,
						focus  : 'center',
						loop		: true,
						rewind		: true,
						cover      	: false,
						perPage: parseInt(perPageAttr),
						gap: gap,
						padding:0,
						lazyLoad: lazyload,
						pagination 	: (slides.length > 1) ? arrows : false,
						arrows     	: (slides.length > 1) ? pagination : false,
						/** /
						autoScroll: {
							speed: direction,
							autoStart: false,
							pauseOnHover: pauseOnHover
						},
						
						intersection: {
							inView: {
								autoScroll: autoStart
							},
							outView: {
								autoScroll: false
							},
						},
						/**/
						breakpoints: {
							1920: {
								gap: 8,
								perPage	: parseInt(perPageAttr),
							},
							1440: {
								gap: 8,
								perPage	: parseInt(perPageAttr),
							},
							1280: {
								gap: 8,
								perPage	: parseInt(perPageAttr),
							},
							1024: {
								gap: 8,
								perPage	: parseInt(perPageAttr),
							},
							768: {
								gap: 8,
								perPage	: 1
							},
							640: {
								gap: 8,
								perPage	: 1
							}
						}
						/**/
					} );

					primarySlider.on( 'ready', function () {
						console.log('REVIEWS CAROUSEL READY');
					} );

					// Fired right after the carousel moves.
					primarySlider.on( 'visible', function (slide) {
						console.info('REVIEWS CAROUSEL VISIBLE', slide);
						return;
					} );

					// Fired when any slide gets hidden from the view port.
					primarySlider.on( 'hidden', function (slide) {
						console.info('REVIEWS CAROUSEL HIDDEN', slide);
						return;
					});

					// Fired right before the carousel moves.
					primarySlider.on( 'move', function () {
						console.info('REVIEWS CAROUSEL MOVING');
					} );

					// Fired right after the carousel moves.
					primarySlider.on( 'moved', function () {
						console.info('REVIEWS CAROUSEL MOVED');
					} );

					//primarySlider.mount({ AutoScroll, Intersection });
					primarySlider.mount({ Intersection });
					
					slides.forEach((slide)=>{
						const pageTransition = document.body.querySelector('e-page-transition');
						slide.addEventListener('click',(evt)=>{
							const target =  evt.currentTarget;
							if( target ) {
								const customLink =  target.getAttribute('data-link');
								
								if( customLink ) {

									if( pageTransition ) {
										pageTransition.classList.remove('e-page-transition--entered');
										pageTransition.classList.add('e-page-transition--exiting');
									}

									const tt = setTimeout(()=>{
										window.location = customLink;
										clearTimeout(tt);
									}, 750);
									
								}
							}
							
						});
					});

				});
			}

		}, false);

	});

})();
